module.exports = "/images/icon-withdrawal.png?557e5d87ba8baf3593748ec87cb74901";